import React from 'react';
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart, Subtitle, CointainerFigureImage } from '../../components/AppComponents';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import highchartsGroupedCategories from 'highcharts-grouped-categories';
import { figure49 } from '../../graphs/es/figure49';
import { figure51 } from '../../graphs/es/figure51';
import { figure52 } from '../../graphs/es/figure52';
import { figure54 } from '../../graphs/es/figure54';
// import { figure55 } from '../graphs/en/figure55';
// eslint-disable-next-line
highchartsMore(Highcharts);
highchartsGroupedCategories(Highcharts);

const Sdg15 = () => {
    return (
      
        <React.Fragment>
            <ContainerCoverVideo 
                id="15" 
                poster="http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/poster-sdg-15.png"
                video="http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/video-sdg-15.mp4"
                sdgImage="http://www.fao.org/images/corporatelibraries/sdg-logo/sdg15-es.svg"
                sdg="OBJETIVO DE DESARROLLO SOSTENIBLE 15"
                title="Vida de ecosistemas terrestres"
                subtitle="Gestionar sosteniblemente los bosques, luchar contra la desertificación, detener e invertir la degradación de las tierras y detener la pérdida de biodiversidad."
                summaryTable='http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/summary-tables/summary-table-15.pdf'
                indicators={['15.1.1', '15.2.1', '15.4.2', '15.6.1']}  
                indicatorsTitle="Indicadores"
                summaryTableTitle= "TABLA DE RESUMEN"
            />

            <Container>
                <TitleSub title="Visión general" />
                <p>La deforestación y la degradación de los bosques, la pérdida continuada de biodiversidad y la degradación en curso de los ecosistemas están teniendo profundas consecuencias para el bienestar y la supervivencia de los seres humanos. El mundo no alcanzó las metas de 2020 para detener la pérdida de biodiversidad. La superficie forestal sigue disminuyendo, aunque a un ritmo más lento que en decenios anteriores, y un sinfín de especies siguen en peligro de extinción. La pandemia de la COVID-19 ha confirmado que, al amenazar la biodiversidad, la humanidad amenaza su propia supervivencia. Aunque se está trabajando de forma intensa para ampliar la gestión sostenible de los bosques, aumentar la cobertura de las zonas clave de la biodiversidad y suscribir la legislación y los tratados para proteger la biodiversidad y los ecosistemas, la comunidad internacional tendrá que redoblar los esfuerzos encaminados a proteger los ecosistemas terrestres para “poner la salud del planeta en el centro de todos nuestros planes y políticas” (Secretario General de las Naciones Unidas).</p>

                <div id="section15.1.1">
                    <HeaderSdg 
                        title="INDICADOR 15.1.1 DE LOS ODS"
                        subtitle="Superficie forestal en proporción a la superficie total"
                        badges={[
                            {color: '#cecece', text: 'Evaluación de la situación: imposible de realizar debido a la ausencia de un criterio numérico en la meta'},
                            {color: '#ff0100', text: 'Evaluación de la tendencia: deterioro'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.1',
                            text: 'De aquí a 2020, asegurar la conservación, el restablecimiento y el uso sostenible de los ecosistemas terrestres y los ecosistemas interiores de agua dulce y sus servicios, en particular los bosques, los humedales, las montañas y las zonas áridas, en consonancia con las obligaciones contraídas en virtud de acuerdos internacionales.'
                        }}
                    />
                </div>

                <p><i>En 2020, un 31,2 % de la superficie terrestre estaba cubierta por bosques; esto supone que en los dos últimos decenios la cubierta forestal se ha reducido en 100 millones de hectáreas.</i></p>
                <p>La proporción de superficie forestal con respecto a la superficie terrestre del planeta ha disminuido gradualmente desde el 31,9 % en el año 2000 (4 200 millones de hectáreas) hasta el 31,5 % en 2010, para posteriormente bajar al 31,2 % (4 100 millones de hectáreas) en 2020. Las pérdidas de superficie forestal ascendieron a casi 100 millones de hectáreas en los dos últimos decenios; sin embargo, el ritmo de pérdida se ha ralentizado ligeramente en los últimos 10 años. Estas tendencias mundiales son el resultado de dinámicas contrapuestas de las regiones:</p>
                <ul>
                    <li>Asia, así como Europa y América del Norte registraron un incremento general de la superficie forestal entre los años 2000 y 2020, gracias a los esfuerzos de forestación y restauración del paisaje y a la expansión natural de los bosques en estas regiones. No obstante, la expansión de la superficie forestal se ralentizó entre 2010 y 2020 en comparación con el período 2000-2010.</li>
                    <li>Por su parte, en América Latina y el Caribe así como en el África subsahariana se han observado grandes pérdidas de superficie forestal en los últimos 20 años, debido principalmente a la conversión de los bosques para su uso con fines agrícolas y de pastoreo. Los PMA se ven especialmente afectados por las pérdidas de superficie forestal. En América Latina y el Caribe, las pérdidas forestales disminuyeron en el período 2010-2020 en relación con el decenio anterior, mientras que en el África subsahariana se observó un incremento.</li>
                </ul>
                <p>Los bosques desempeñan una importante función para los medios de vida y el bienestar de la población rural y urbana. Contribuyen notablemente a regular el ciclo del agua y mitigar el cambio climático, al tiempo que albergan la mayor parte de la biodiversidad terrestre del planeta. La pérdida de bosques contribuye al calentamiento global y tiene efectos negativos, especialmente en los medios de vida de la población más pobre, en usos interrelacionados de la tierra como la agricultura, así como en la flora y fauna silvestres y otros servicios ambientales.</p>
                <p>Se prevé que la crisis de la COVID-19 tenga un efecto negativo en los recursos forestales y aumente el riesgo de deforestación, con la consiguiente pérdida de biodiversidad. Los bosques desempeñan un papel fundamental a fin de garantizar los medios de vida de la población más vulnerable y aumentar la capacidad de resistencia frente a crisis como las pandemias. Por lo tanto, existe el riesgo de que aumente la presión sobre la cubierta forestal y la integridad ambiental si no se aplican otras medidas de apoyo.</p>
                <p>Mantener el impulso para detener la deforestación y la degradación de los bosques y restaurar los ecosistemas dañados será fundamental para mejorar la resiliencia al cambio climático de los ecosistemas, evitar la pérdida de biodiversidad y mejorar los medios de vida rurales, especialmente en los trópicos y en los países menos adelantados.</p>
                <p>Esta actualización anual del indicador 15.1.1 utiliza los datos más recientes de la <i>Evaluación de los recursos forestales mundiales de la FAO de 2020</i> (FAO, 2021e), que se basa en los mejores datos e información disponibles de los países hasta la fecha.</p>
            </Container>

            <ContainerChart 
                title="Figura 49: Indicador 15.1.1 de los ODS Superficie forestal en proporción a la superficie total (porcentaje)" 
                legend={[
                    {title: '2000', color: '#00b050'},             
                    {title: '2010', color: '#92d050'},
                    {title: '2020', color: '#385723'}
                ]}>
                    
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure49}
                />
            </ContainerChart>

            <CointainerFigureImage
                title="Figura 50: Indicador 15.1.1 de los ODS Superficie forestal en proporción a la superficie total, 2015-2020" 
                image={'http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/figurefinal50.png'}
                legendCSSClass="half-width-entries"
                legend={[
                    {title: '1 - Mejora', color: '#006400', customCSSClass: 'half-width'},
                    {title: '2 - Mejora leve o nula', color: '#28cb28', customCSSClass: 'half-width'},
                    {title: '3 - Ligero deterioro', color: '#ffa400', customCSSClass: 'half-width'},
                    {title: '4 - Deterioro', color: '#ff0000', customCSSClass: 'half-width'},
                    {title: '5 - Datos insuficientes', color: '#808080', customCSSClass: 'half-width mr-auto'}
                ]}
                note={<span>La línea de puntos representa aproximadamente la Línea de Control en Jammu y Cachemira convenida por la India y el Pakistán.  Las partes no han llegado todavia a un acuerdo sobre el estatuto definitivo de Jammu y Cachemira. Las fronteras definitivas entre la República del Sudán y la República de Sudán del Sur no se han determinado todavía.<br />
                    Fuente: FAO, 2021c, modificado para cumplir con ONU Geoespacial, 2021.</span>}>
            </CointainerFigureImage>

            <Container>
                <div id="section15.2.1">
                    <HeaderSdg 
                        title="INDICADOR 15.2.1 DE LOS ODS"
                        subtitle="Avances hacia la gestión forestal sostenible"
                        badges={[
                            {color: '#cecece', text: 'Evaluación de la situación: imposible de realizar debido a la ausencia de un criterio numérico en la meta'},
                            {color: '#cecece', text: 'Evaluación de la tendencia: no realizada por motivos metodológicos'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.2',
                            text: 'De aquí a 2020, promover la puesta en práctica de la gestión sostenible de todos los tipos de bosques, detener la deforestación, recuperar los bosques degradados y aumentar considerablemente la forestación y la reforestación a nivel mundial.'
                        }}
                    />
                </div>
                
                <p><i>Se han realizado avances significativos en todo el mundo en relación con la gestión forestal sostenible, pero la pérdida de bosques sigue siendo elevada.</i></p>
                <p>El indicador 15.2.1 muestra progresos evidentes en relación con la gestión sostenible de los bosques del mundo. La mayoría de los subindicadores muestran tendencias positivas, al comparar el período 2010-2020 con el período 2000-2010, lo cual demuestra que se están realizando esfuerzos satisfactorios para conservar y utilizar de manera sostenible los bosques.</p>
                <p>A nivel mundial, en la mayoría de las regiones se han registrado incrementos en los siguientes subindicadores:</p>
                <ul>
                    <li>la superficie forestal con certificación;</li>
                    <li>el porcentaje de superficie forestal en áreas protegidas y sometida a planes de gestión a largo plazo;</li>
                    <li>la biomasa forestal por encima del suelo por hectárea. </li>
                </ul>
                <p>El número de países con superficie forestal certificada ha aumentado de 80 en 2019 a 83 en 2020.</p>
                <p>La única excepción a esta tendencia es la tasa de variación de la superficie forestal, que muestra una leve disminución en la tasa de pérdida de bosques a nivel mundial, por lo que sigue siendo un motivo de preocupación. Los datos de la <i>Evaluación de los recursos forestales mundiales de la FAO de 2020 </i>(FRA 2020) revelan que, en África y Asia sudoriental, la pérdida de bosques en los últimos 10 años ha sido superior a la que se registró en el decenio anterior. La pérdida de bosques también sigue siendo elevada en América Latina y el Caribe, aunque a un menor ritmo que antes. En estas regiones, la conversión de los bosques para fines agrícolas a gran escala (especialmente en América Latina y Asia sudoriental), pastoreo y agricultura de subsistencia (África) es el principal factor causante de la pérdida de bosques.</p>
                <p>La deforestación y la degradación de los bosques siguen constituyendo dos de los principales desafíos, especialmente en los trópicos, los PMA, los PDL y los PEID. Por ello, es necesario seguir reforzando la gobernanza forestal en todos los niveles.</p>
                <p>Los bosques son las mayores reservas de carbono y biodiversidad del planeta. Son fuentes esenciales de alimentos, bienes y servicios y resultan fundamentales para los medios de vida de la población más pobre y las comunidades rurales.</p>
                <p>A medida que la pandemia de la COVID-19 sigue propagándose por todo el planeta, también afecta a los bosques y las actividades forestales de muchas maneras. Existe un mayor riesgo de aumento de la deforestación y, en consecuencia, de pérdida de la biodiversidad, pues determinados grupos de población están perdiendo sus puestos de trabajo y sus ingresos y recurren a los bosques y los productos forestales para subsistir, ejerciendo una mayor presión sobre los recursos forestales. El refuerzo de la vigilancia y la aplicación de la ley con miras a frenar las actividades ilegales y apoyar a las personas más vulnerables constituyen medidas esenciales para mitigar la deforestación y la degradación impulsadas por la pandemia.</p>
                <p>Los bosques pueden desempeñar un papel fundamental para aportar soluciones a crisis como la pandemia de la COVID-19. Actúan como redes de seguridad para los miembros más vulnerables de la sociedad, proporcionando alimentos, subsistencia e ingresos en tiempos de escasez y aumentando así su capacidad de recuperación.</p>
                <p>Se deberían promover enérgicamente los esfuerzos a escala mundial y regional para mantener los ecosistemas forestales, así como sus funciones social, económica y ambiental, haciendo especial hincapié en los trópicos y los países en desarrollo.</p>
                <p>En esta actualización anual del indicador 15.2.1 de los ODS se utilizan los datos más recientes de la FRA 2020 (FAO, 2021e), así como datos de certificación actualizados para el año 2020. La Evaluación de los recursos forestales mundiales se basa en los mejores datos e información disponibles de los países hasta la fecha.</p>   
            </Container>

            <div className="chart-container">
                <div className="chart-title"><h2>15.2.1 Tablero para los subindicadores de los ODS</h2></div>
                <table className="table desktop-table">
                    <thead className="subcategory_thead table-prevalence-title enter">
                        <tr>
                            <th>Región de los ODS</th>
                            <th className="rotate">
                                <div><span>Tasa de variación anual de la<br />superficie forestal<sup>*</sup></span></div>
                            </th>
                            <th className="rotate">
                                <div><span>Existencias de biomasa por encima del suelo<br />en los bosques (t/ha)</span></div>
                            </th>
                            <th className="rotate pb-0">
                                <div><span>
                                Porcentaje de la superficie forestal dentro<br />de áreas protegidas legalmente establecidas</span></div>
                            </th>
                            <th className="rotate pb-0">
                                <div><span>Porcentaje de la superficie forestal sometida<br />a un plan de gestión forestal a largo plazo</span></div>
                            </th>
                            <th className="rotate">
                                <div><span>Superficie forestal certificada</span></div>
                            </th>
                        </tr>
                    </thead>
                    <thead className="category_thead enter">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <thead className="othcategory_thead enter">
                        <tr>
                            <th scope="row">Mundo</th>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                    </thead>
                    <tbody className="enter">
                        <tr>
                            <th scope="row" className="indent">Asia central y meridional</th>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Asia Central</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Asia meridional</th>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Asia oriental y sudoriental</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Asia oriental</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Asia sudoriental</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">África septentrional y Asia occidental</th>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">África septentrional</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Asia occidental</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">África subsahariana</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Europa y América del Norte</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Europa</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">América del Norte</th>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">América Latina y el Caribe</th>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Oceanía</th>
                            <td className="green"></td>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Oceanía (excluidas Australia y Nueva Zelandia)</th>
                            <td className="yellow"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent-2">Australia y Nueva Zelandia</th>
                            <td className="green"></td>
                            <td className="red"></td>
                            <td className="green"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Países en desarrollo sin litoral (PDL)</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="red"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Países menos adelantados (PMA)</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                        <tr>
                            <th scope="row" className="indent">Pequeños Estados insulares en desarrollo (PEID)</th>
                            <td className="red"></td>
                            <td className="yellow"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                            <td className="green"></td>
                        </tr>
                    </tbody>
                </table>


                <table className="table mobile-table">
                    <tbody>
                        <tr>
                                <td colSpan="2" className="country text-center font-weight-bold">Mundo</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia central y meridional</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia Central</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia meridional</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia oriental y sudoriental</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asie de l’Est</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia sudoriental</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">África septentrional y Asia occidental</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">África septentrional</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Superficie forestal certificada</td>
                            <td className="data red"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Asia occidental</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">África subsahariana</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Superficie forestal certificada</td>
                            <td className="data red"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Europa y América del Norte</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Europa</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">América del Norte</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">América Latina y el Caribe</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Oceanía</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Oceanía (excluidas Australia y Nueva Zelandia)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Australia y Nueva Zelandia</td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Países en desarrollo sin litoral (PDL)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Superficie forestal certificada</td>
                            <td className="data red"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Países menos adelantados (PMA)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="country text-center font-weight-bold">Pequeños Estados insulares en desarrollo (PEID)</td>
                        </tr>
                        <tr>
                            <td className="data border-left-red">Tasa de variación anual de la superficie forestal<sup>*</sup></td>
                            <td className="data red"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-yellow">Existencias de biomasa por encima del suelo en los bosques (t/ha)</td>
                            <td className="data yellow"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal dentro de áreas protegidas legalmente establecidas</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Porcentaje de la superficie forestal sometida a un plan de gestión forestal a largo plazo</td>
                            <td className="data green"></td>
                        </tr>
                        <tr>
                            <td className="data border-left-green">Superficie forestal certificada</td>
                            <td className="data green"></td>
                        </tr>
                    </tbody>
                </table>

                <ul className="list-unstyled list-inline text-center legend legend-table mt-4">
                    <li className="list-inline-item"><span className="point position-static"></span>Variación positiva</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variación escasa/Sin variaciones</li>
                    <li className="list-inline-item"><span className="point position-static"></span>Variación negativa</li>
                </ul>

                <p className="note text-center"><sup>*</sup>Calculada empleando la fórmula de interés compuesto.
                <br />Fuente: FAO, 2021c.</p>
            </div>

            <Container>
                <div id="section15.4.2">
                    <HeaderSdg 
                        title="INDICADOR 15.4.2 DE LOS ODS"
                        subtitle="Índice de cobertura verde las montañas"
                        badges={[
                            {color: '#cecece', text: 'Evaluación de la situación: imposible de realizar debido a la ausencia de un criterio numérico en la meta'},
                            {color: '#c4e0b3', text: 'Evaluación de la tendencia: mejora leve o nula'},
                        ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.4',
                            text: 'De aquí a 2030, asegurar la conservación de los ecosistemas montañosos, incluida su diversidad biológica, a fin de mejorar su capacidad de proporcionar beneficios esenciales para el desarrollo sostenible.'
                        }}
                    />
                </div>
                
                <p><i>Los ecosistemas de montaña son zonas de alta diversidad biológica terrestre. Sin embargo, son especialmente vulnerables al cambio climático, lo cual pone en riesgo la biodiversidad y los medios de vida de las personas que viven en zonas montañosas y tierras bajas adjacentes.</i></p>
                <p>Las montañas abarcan aproximadamente el 22 % de la superficie terrestre y albergan a unos 915 millones de personas. Contienen más del 85% de las especies de anfibios, aves y mamíferos del mundo. Además, proporcionan recursos vitales, como agua potable, a una proporción significativa de la población mundial.</p>
                <p>Sin embargo, los ecosistemas montañosos son especialmente vulnerables al cambio climático, el cual supone una amenaza para su capacidad de continuar proporcionando servicios ecosistémicos. Esto resulta especialmente alarmante teniendo en cuenta que las personas que viven en las montañas ya se encuentran entre la población más afectada por la inseguridad alimentaria a nivel mundial, pues aproximadamente uno de cada tres habitantes de las zonas montañosas se enfrenta a la amenaza de la inseguridad alimentaria.</p>
                <p>La cobertura verde de las montañas puede porporcionar información sobre el estado de salud de estas áreas y, por tanto, con su capacidad para cumplir sus funciones ecosistémicas. Nuevos datos basados en imágenes por satélite con una resolución de 300 m revelan que alrededor del 73 % de las montañas del mundo están cubiertas de vegetación (bosques, pastizales, humedales y tierras cultivables).</p>
                <ul>
                    <li>Oceanía es la región con la mayor proporción de cobertura verde en las montañas, con más del 95 %.</li>
                    <li>Asia occidental y África septentrional registran la cobertura más escasa con un porcentaje de cerca del 55 %.</li>
                    <li>África subsahariana tiene una cobertura montañosa del 92 %, seguida por Asia oriental y meridional con un 85 % y América Latina y el Caribe con un 81 %.</li>
                    <li>América del Norte y Europa y Asia central y meridional registran coberturas verdes de las montañas comprendidas entre el 65 % y el 67 %.</li>
                </ul>
                <Subtitle text="Interpretación de la cobertura verde de las zonas montañosas" />
                <p>Puesto que es un indicador agregado, la cobertura verde de las zonas montañosas debería interpretarse con precaución. La cifra correspondiente a la cobertura verde no proporciona detalles sobre la variación de especies ni tampoco sobre la variación del límite de la vegetación arbórea. Además, no todos los cambios en la cobertura verde pueden considerarse "positivos" (por ejemplo, el aumento de la cobertura verde como resultado del retroceso de los glaciares y la pérdida de la capa de nieve).</p>
                <p>Comprender la variación de la composición de las especies y el límite de la vegetación arbórea resultará importante para determinar las consecuencias a largo plazo del cambio climático en las regiones montañosas. Por tanto, será importante analizar la variación de cada una de las zonas de elevación a lo largo del tiempo para determinar las medidas de gestión y adaptación adecuadas.</p>
                <Subtitle text="Datos desglosados por tipo de cobertura del suelo y elevación" />
                <p>La Figura 51 ofrece una representación gráfica de la cubierta montañosa mundial, desglosada por tipo de cobertura del suelo y elevación para facilitar una comprensión más detallada de los patrones de la cubierta montañosa mundial.</p>
                <ul>
                    <li><b>Bosque</b>: Situados en la elevación más baja, los bosques son el tipo de cobertura del suelo predominante, pues abarcan más del 50 % de la superficie. No obstante, el porcentaje de cubierta forestal disminuye de manera progresiva a medida que aumenta la elevación, alcanzando valores casi insignificantes por encima de los 4 500 metros.</li>
                    <li><b>Pastizales y otras tierras</b>: La proporción de la superficie montañosa cubierta por pastizales y otras tierras (que pueden incluir capas de hielo, glaciares y terrenos rasos) generalmente aumenta con la elevación, y los pastizales son el tipo de cobertura del suelo predominante por encima de los 3 500 metros.</li>
                    <li><b>Tierra cultivable</b>: De los distintos rangos de elevación, las tierras cultivables son las más extendidas entre los 1 500 y los 2 500 metros, lo cual probablemente refleja el hecho de que las montañas situadas a una elevación menor también se caracterizan por una pendiente y un rango de elevación local más altos, por lo cual es posible que no constituyan un terreno adecuado para el cultivo. Por encima de los 2 500 metros, la cobertura de cultivos de las montañas también se reduce progresivamente.</li>
                    <li><b>Asentamientos y humedales</b>: El porcentaje de cobertura de los asentamientos y humedales en las montañas es insignificante en todos los rangos de elevación, aunque también muestra una tendencia descendente a mayores altitudes.</li>
                </ul>
                <p>La mejora de la precisión, la frecuencia y la resolución de los datos geoespaciales permitirá en el futuro realizar un análisis más preciso de la variación de la cubierta verde en los diferentes tipos de elevaciones y cobertura del suelo.</p>
            </Container>


            <ContainerChart 
                title="Figura 51: Cobertura mundial de las montañas, desglosada por elevación y tipo de cobertura del suelo" 
                legend={[]}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure51}
                />
            </ContainerChart>

            <div className="fakeLegendWrapper">
             <div className="fakeLegend">
                <h6>Escala de elevación de Kapos simplificada</h6>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Clase 1</th>
                        <th scope="col">Clase 2</th>
                        <th scope="col">Clase 3</th>
                        <th scope="col">Clase 4</th>
                        <th scope="col">Clase 5</th>
                        <th scope="col" className="fakeLegendBorder">Clase 6</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>&lt; 4 500 metros</td>
                            <td>3 500-4 500 metros</td>
                            <td>2 500-3 500 metros</td>
                            <td>1 500-2 500 metros</td>
                            <td>1 000-1 500m LER &lt; 300m</td>
                            <td className="fakeLegendBorder">300-1 000m LER &lt; 300m</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>

            <ContainerChart 
                title="Figura 52: Índice de cobertura verde de las montañas por región, 2018" 
                legend={[]}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure52}
                />
            </ContainerChart>

            <Container>
            <p>En la Figura 53 se representan los cambios en el índice de cobertura verde de las montañas de 2015 a 2018, en diferentes regiones del mundo. La figura muestra las tendencias del indicador solo para los países para los que existen datos y estos han sido validados; los países cuyos datos aún no se han validado se representan en gris. </p>
            </Container>

            <CointainerFigureImage
                title="Figura 53: Avances en la mejora del índice de cobertura verde de las montañas por región, 2015-18" 
                image={'http://www.fao.org/fileadmin/templates/SDG-progress-report/2021/static/media/figurefinal53.png'}
                legendCSSClass="half-width-entries"
                legend={[
                    {title: '1 - Mejora', color: '#006400', customCSSClass: 'half-width'},
                    {title: '2 - Mejora leve o nula', color: '#28cb28', customCSSClass: 'half-width'},
                    {title: '3 - Ligero deterioro', color: '#ffa400', customCSSClass: 'half-width'},
                    {title: '4 - Deterioro', color: '#ff0000', customCSSClass: 'half-width'},
                    {title: '5 - Datos insuficientes', color: '#808080', customCSSClass: 'half-width mr-auto'}
                ]}
                note={<span>La línea de puntos representa aproximadamente la Línea de Control en Jammu y Cachemira convenida por la India y el Pakistán.  Las partes no han llegado todavia a un acuerdo sobre el estatuto definitivo de Jammu y Cachemira. Las fronteras definitivas entre la República del Sudán y la República de Sudán del Sur no se han determinado todavía.<br />
                    Fuente: FAO, 2021c, modificado para cumplir con ONU Geoespacial, 2021.</span>}>
            </CointainerFigureImage>

            <Container>
                <div id="section15.6.1">
                    <HeaderSdg
                        title="INDICADOR 15.6.1 DE LOS ODS"
                        subtitle="Número de países que han adoptado marcos legislativos, administrativos y normativos para asegurar una distribución justa y equitativa de los beneficios"
                        // badges={[
                        //     {color: '#ffbf02', text: 'Status assessment: Not possible due to absence of numerical yardstick in target'},
                        //     {color: '#ff0100', text: 'Trend assessment: Légère amélioration ou non-amélioration'},
                        // ]}
                        target={{
                            sdg: "15",
                            title: 'Meta 15.6',
                            text: 'Promover la participación justa y equitativa en los beneficios derivados de la utilización de los recursos genéticos y promover el acceso adecuado a esos recursos, según lo convenido internacionalmente.'
                        }}
                    />
                </div>

                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Series de datos</th>
                        <th scope="col">Evaluación de la tendencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Países que son Partes en el Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura (FAO, 2021f).</td>
                            <td>Mejora</td>
                        </tr>
                        <tr>
                            <td>Países que notificaron tener establecido un marco o medidas de carácter legislativo, administrativo y normativo a través del Sistema en línea para la notificación del cumplimiento del Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura.</td>
                            <td>Mejora</td>
                        </tr>
                        <tr>
                            <td>Número total comunicado de Acuerdo normalizado de transferencia de material (ANTM) que transfieren recursos fitogenéticos para la alimentación y la agricultura al país.</td>
                            <td>Mejora</td>
                        </tr>
                    </tbody>
                </table>

                <p><i>Un número cada vez mayor de países está tomando medidas para garantizar el acceso a los Recursos Fitogenéticos para la Alimentación y la Agricultura (RFAA) y la distribución de beneficios conexa, pero se deben intensificar los esfuerzos.</i></p>
                <p>El Protocolo de Nagoya sobre acceso a los recursos genéticos y participación justa y equitativa en los beneficios que se deriven de su utilización entró en vigor el 12 de octubre de 2014 como acuerdo complementario del Convenio sobre la Diversidad Biológica (CDB), a fin de avanzar ulteriormente en el tercer objetivo del Convenio. El Protocolo se encuentra todavía en las fases iniciales de ejecución. No obstante, muchas Partes en el Protocolo de Nagoya, así como los países que no son Partes, han hecho progresos considerables en el establecimiento de marcos de acceso y distribución de beneficios (ADB).</p>
                <p>A fecha de 1 de febrero de 2021, un total de 128 países y la Unión Europea han ratificado el Protocolo y 67 países y la Unión Europea han adoptado marcos de ADB y han publicado la información correspondiente en el Centro de Intercambio de Información sobre Acceso y Participación en los Beneficios. Hasta el momento, se han emitido 2 110 certificados de cumplimiento reconocidos internacionalmente en 22 países; además, seis países han publicado 44 comunicados de puntos de control. La Secretaría del CDB está colaborando con los países para facilitar este proceso.</p>
                <Subtitle text="Facilitación del acceso a los recursos vegetales" />
                <p><a href="http://www.fao.org/plant-treaty/es/" target="_blank" rel="noreferrer">El Tratado Internacional sobre los Recursos Fitogenéticos para la Alimentación y la Agricultura</a> facilita el acceso al material fitogenético a los agricultores y fitomejoradores para que puedan desarrollar nuevas variedades de cultivos a fin de adaptar la producción agrícola a entornos cambiantes, con el objetivo de mejorar la seguridad alimentaria mundial. El intercambio de material de plantación brinda la oportunidad de compartir los beneficios monetarios y no monetarios derivados de la utilización de dicho material con los agricultores de los países en desarrollo, lo que constituye un importante incentivo para que estos sigan conservando y utilizando de forma sostenible el material fitogenético.</p>
                <p>Hasta febrero de 2021, un total de 57 países habían presentado informes en el marco de los Procedimientos de cumplimiento sobre sus medidas de ADB para facilitar el intercambio de material de plantación, si bien hay 148 Partes Contratantes en el Tratado. Hasta la fecha, se han transferido más de 5,5 millones de muestras en todo el mundo mediante más de 78 000 contratos —conocidos como acuerdos normalizados de transferencia de material (ANTM)— utilizados por 6 447 receptores de 181 países para facilitar el intercambio de material fitogenético.</p>
            </Container>

            <ContainerChart
                title="Figura 54: Número de acuerdos normalizados de transferencia de material (ANTM) mediante los cuales se han transferido RFAA en el mundo, 2012-2021" 
                legendCSSClass="half-width-entries"
                legend={[
                    {title: 'Mundo', color: '#4f81bd', customCSSClass: 'half-width'},
                    {title: 'África septentrional', color: '#c0504d', customCSSClass: 'half-width'},
                    {title: 'Australia y Nueva Zelandia', color: '#b2cb80', customCSSClass: 'half-width'},
                    {title: 'Asia central y meridional', color: '#a794bf', customCSSClass: 'half-width'},
                    {title: 'Asia occidental', color: '#4bacc6', customCSSClass: 'half-width'},
                    {title: 'África subsahariana', color: '#f79646', customCSSClass: 'half-width'},
                    {title: 'América Latina y el Caribe', color: '#6a819d', customCSSClass: 'half-width'},
                    {title: 'Oceanía (excluidas Australia y Nueva Zelandia)', color: '#a97978', customCSSClass: 'half-width'},
                    {title: 'Asia oriental y Asia sudoriental', color: '#5f7530', customCSSClass: 'half-width mr-auto'},
                ]}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure54}
                />
            </ContainerChart>

        </React.Fragment>
    )
}


export default Sdg15;
